//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../components/Table/Table.vue'
import { formatTrueFalse, formatTime, convertTime } from '../../components/helpers.js'
import TableComponentServerSingleWithFilter from '../../components/TableComponent/TableComponentServerSingleWithFilter.vue'

export default {
  components: {
    Table,
    TableComponentServerSingleWithFilter
  },
  props: {
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      waybillTableColumns: [
        {
          name: 'createTime',
          label: 'Дата/время создания',
          align: 'left',
          field: 'createTime',
          format: formatTime,
          sortable: true
        },
        {
          name: 'validityEndTime',
          label: 'Действителен до',
          align: 'left',
          field: 'validityEndTime',
          format: formatTime,
          sortable: true
        },
        {
          name: 'series',
          label: 'Серия',
          align: 'left',
          field: 'series',
          sortable: true
        },
        {
          name: 'number',
          label: 'Номер',
          align: 'left',
          field: 'number',
          sortable: true
        },
        {
          name: 'tripNumber',
          label: 'Номер рейса',
          align: 'left',
          field: 'tripNumber',
          sortable: true
        },
        {
          name: 'state',
          label: 'Статус',
          align: 'left',
          field: 'state',
          format: state => state.alias,
          sortable: true
        },
        {
          name: 'gosNumber',
          label: 'ГРЗ ТС',
          align: 'left',
          field: 'gosNumber',
          sortable: true
        },
        {
          name: 'driverFIO',
          label: 'ФИО водителя',
          align: 'left',
          field: 'driverFIO',
          sortable: true
        }
      ],
      loading: false,
      selectedItem: null
    }
  },
  mounted: function () {
    this.selectedItem = this.params && this.params.selectedItem
  },
  methods: {
    onSelected: function (selection) {
      this.selectedItem = selection
      this.$emit('selected-item', { type: this.params.type, selectedItem: selection })
    },
    onSaveSelection: function () {
      this.$emit('save-selection', this.params.type)
    },
    onCloseModal: function () {
      this.$emit('close-selection', this.params.type)
    },
    getColumns: function () {
      const paramsType = this.params && this.params.type !== undefined ? this.params.type : null
      let columns = []
      switch (paramsType) {
        case 'showVehiclesTable':
          columns = [
            {
              name: 'name',
              label: 'Название',
              align: 'left',
              field: 'name',
              classes: 'class-bordered',
              headerStyle: 'width: 100px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'gosNumber',
              label: 'ГРЗ',
              align: 'left',
              field: 'gosNumber',
              classes: 'class-bordered',
              headerStyle: 'width: 90px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'garageNumber',
              label: 'ГН',
              align: 'left',
              field: 'garageNumber',
              classes: 'class-bordered',
              headerStyle: 'width: 50px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'model',
              label: 'Модель',
              align: 'left',
              field: 'model',
              classes: 'class-bordered',
              headerStyle: 'width: 150px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'vehicleTypeName',
              label: 'Тип',
              align: 'left',
              field: 'vehicleTypeName',
              classes: 'class-bordered',
              headerStyle: 'width: 120px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'dontGiveUntilFix',
              label: 'Запрещено выдавать',
              align: 'left',
              field: 'dontGiveUntilFix',
              classes: 'class-bordered',
              format: formatTrueFalse,
              headerStyle: 'width: 150px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'issued',
              label: 'Выдан',
              align: 'left',
              field: 'issued',
              classes: 'class-bordered',
              format: formatTrueFalse,
              headerStyle: 'width: 120px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'vehicleEmployee',
              label: 'Кому выдан',
              align: 'left',
              field: 'vehicleEmployee',
              classes: 'class-bordered',
              format: vehicleEmployee => vehicleEmployee && vehicleEmployee.fio !== undefined ? vehicleEmployee.fio : null,
              headerStyle: 'width: 120px; white-space: pre-wrap;',
              sortable: true
            }
          ]
          break
        case 'showCardsTable':
        case 'showFuelCardsTable':
          columns = [
            {
              name: 'name',
              label: 'Название карты',
              align: 'left',
              field: 'name',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'number',
              label: 'Номер карты',
              align: 'left',
              field: 'number',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;'
            }
          ]
          break
        case 'showIntegrationActs':
          columns = [
            {
              name: 'param.visTransactionDate',
              label: 'Дата/время транзакции',
              align: 'left',
              field: 'param.visTransactionDate',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;',
              format: convertTime
            },
            {
              name: 'name',
              label: 'Название',
              align: 'left',
              field: 'name',
              classes: 'class-bordered',
              headerStyle: 'width: 250px; white-space: pre-wrap;',
              sortable: true
            },
            {
              name: 'param.cardNumber',
              label: 'Номер топливной карты',
              align: 'left',
              field: 'param.cardNumber',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;'
            }
          ]
          if (this.formId == 'wash') {
            columns.push(...[
              {
                name: 'param.washingCost',
                label: 'Стоимость, руб',
                align: 'left',
                field: 'param.washingCost',
                classes: 'class-bordered',
                headerStyle: 'width: 170px; white-space: pre-wrap;'
              },
              {
                name: 'param.servicePointAddress',
                label: 'Адрес мойки',
                align: 'left',
                field: 'param.servicePointAddress',
                classes: 'class-bordered',
                headerStyle: 'width: 400px; white-space: pre-wrap;'
              }
            ])
          } else if (this.formId === 'fuel') {
            columns.push(...[
              {
                name: 'param.fuelVolume',
                label: 'Объём топлива, л',
                align: 'left',
                field: 'param.fuelVolume',
                classes: 'class-bordered',
                headerStyle: 'width: 170px; white-space: pre-wrap;'
              },
              {
                name: 'param.servicePointAddress',
                label: 'Адрес заправки',
                align: 'left',
                field: 'param.servicePointAddress',
                classes: 'class-bordered',
                headerStyle: 'width: 400px; white-space: pre-wrap;'
              }
            ])
          }

          break
        case 'showAdjustments':
          columns = [
            {
              name: 'param.visTransactionDate',
              label: 'Дата/время транзакции',
              align: 'left',
              field: 'param.visTransactionDate',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;',
              format: convertTime
            },
            {
              name: 'param.fuelCardNumber',
              label: 'Топливная карта',
              align: 'left',
              field: 'param.fuelCardNumber',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;'
            },
            {
              name: 'param.fuelCost',
              label: 'Стоимость, руб',
              align: 'left',
              field: 'param.fuelCost',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;'
            },
            {
              name: 'param.fuelVolume',
              label: 'Объём, л',
              align: 'left',
              field: 'param.fuelVolume',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;'
            },
            {
              name: 'param.fuelType',
              label: 'Тип топлива',
              align: 'left',
              field: 'param.fuelType',
              classes: 'class-bordered',
              headerStyle: 'width: 170px; white-space: pre-wrap;',
              format: objects => objects && objects.map(o => o.name).join(', ')
            }
          ]
          break
        default:
          break
      }
      return columns
    },
    getColumnsSearch: function () {
      const paramsType = this.params && this.params.type !== undefined ? this.params.type : null
      let columns = []
      switch (paramsType) {
        case 'showVehiclesTable':
          columns = ['name', 'model', 'gosNumber', 'vehicleEmployee']
          break
        case 'showFuelCardsTable':
        case 'showCardsTable':
          columns = ['name', 'number']
          break
        case 'showIntegrationActs':
          columns = ['name', 'param.cardNumber', 'param.washingCost', 'param.servicePointAddress']
          break
        default:
          break
      }
      return columns
    }
  }
}
